import React, { useEffect, useState } from "react";
import axios, { API_BASE_URL } from "../api/axios";
import ImageLoader from "../common/ImageLoader";
import "./Benefits.css";

const Benefits = () => {
  const [benefits, setBenefits] = useState([]);
  const [joinLink, setJoinLink] = useState("");
  const [loading, setLoading] = useState(true);

  const BASE_URL = API_BASE_URL;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const benefitsRes = await axios.get("/benefits");
      setBenefits(benefitsRes.data || []);

      const joinLinkRes = await axios.get("/join-link");
      if (joinLinkRes.data?.link) {
        setJoinLink(joinLinkRes.data.link);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleJoinNow = () => {
    if (joinLink) {
      window.open(joinLink, "_blank");
    } else {
      alert("Membership form link not available.");
    }
  };

  const formatPath = (imgSrc) => {
    if (!imgSrc) return "";
    if (imgSrc.startsWith("http")) {
      return imgSrc;
    }
    return `${BASE_URL}/${imgSrc.replace(/\\/g, "/")}`;
  };

  if (loading) {
    return (
      <div className="benefits-container loading-page">
        <div className="loading-spinner"></div>
        <p>Loading member benefits...</p>
      </div>
    );
  }

  return (
    <section id="benefits-page" className="benefits-container">
      <div className="benefits-inner">
        {/* Header Section */}
        <div className="section-header">
          <span className="section-tag">✦ MEMBERSHIP ADVANTAGES</span>
          <h1 className="section-main-title">Why Join ACM?</h1>
          <p className="section-description">
            Unlock exclusive resources, global networking opportunities, technical
            workshops, certifications, and career mentorship with DIET ACM.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="benefits-grid">
          {benefits.map((benefit) => (
            <div key={benefit.id} className="benefits-card glass-panel glow-on-hover">
              <div className="benefit-img-wrapper">
                <ImageLoader
                  src={formatPath(benefit.imgSrc)}
                  alt={benefit.title}
                  className="benefits-image"
                />
              </div>

              <div className="benefit-card-body">
                <h3 className="benefit-card-title">{benefit.title}</h3>
                <p className="benefit-card-desc">{benefit.description}</p>

                {benefit.link ? (
                  <a
                    href={benefit.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="benefits-link"
                  >
                    <span>Learn More</span>
                    <i className="fas fa-arrow-right"></i>
                  </a>
                ) : (
                  <div className="benefits-link-placeholder">
                    <span>Member Exclusive</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Hero Membership Banner */}
        <div className="membership-banner glass-panel">
          <div className="membership-banner-text">
            <h3 className="banner-heading">Ready to Level Up Your Tech Career?</h3>
            <p className="banner-subtext">
              Join hundreds of student developers, researchers, and tech enthusiasts
              in our vibrant community today.
            </p>
          </div>
          <button className="btn-member-action" onClick={handleJoinNow}>
            <i className="fas fa-id-card"></i>
            <span>Become an ACM Member</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Benefits;